import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'
import LoaderPage from 'components/ui/feedback/LoaderPage'

const UploadDocPage = lazy(() => import('pages/upload/page'))

const UploadDocsRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<UploadDocPage />} />} />
    </Routes>
  )
}

export default UploadDocsRoutes
